(() => {
  function selectedExtraVariantIds(root) {
    return Array.from(root.querySelectorAll('select.longarm-extras__select'))
      .filter((sel) => sel.value === 'add')
      .map((sel) => sel.getAttribute('data-variant-id-add'))
      .filter(Boolean);
  }

  function enhanceProductForm(formEl) {
    if (!formEl || formEl.dataset.longarmExtrasBound === 'true') return;
    const extras = formEl.closest('product-info')?.querySelector('[data-longarm-extras="paid"]');
    if (!extras) return;
    formEl.dataset.longarmExtrasBound = 'true';

    formEl.addEventListener(
      'submit',
      async (evt) => {
        const ids = selectedExtraVariantIds(extras);
        if (!ids.length) return; // default Dawn handler

        evt.preventDefault();
        evt.stopImmediatePropagation();

        const submit = formEl.querySelector('[type="submit"]');
        const spinner = formEl.querySelector('.loading__spinner');
        const idInput = formEl.querySelector('input[name="id"]');
        const qtyInput =
          document.querySelector(`input[name="quantity"][form="${formEl.getAttribute('id')}"]`) ||
          formEl.querySelector('input[name="quantity"]');

        if (submit) {
          submit.setAttribute('aria-disabled', 'true');
          submit.classList.add('loading');
        }
        if (spinner) spinner.classList.remove('hidden');

        const items = [{ id: Number(idInput?.value), quantity: Number(qtyInput?.value || 1) }];
        ids.forEach((vid) => items.push({ id: Number(vid), quantity: 1 }));

        try {
          const res = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          const data = await res.json();
          if (data.status) {
            const errWrap = formEl.querySelector('.product-form__error-message-wrapper');
            const errMsg = formEl.querySelector('.product-form__error-message');
            if (errWrap && errMsg) {
              errWrap.removeAttribute('hidden');
              errMsg.textContent = data.description || data.message || 'Could not add to cart';
            }
            return;
          }
          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          if (cart && typeof cart.renderContents === 'function') {
            // refresh cart sections
            const sectionsRes = await fetch((window.routes?.cart_url || '/cart') + '.js');
            const cartJson = await sectionsRes.json();
            // fallback: open cart page if drawer API mismatch
            window.location.href = window.routes?.cart_url || '/cart';
            return;
          }
          window.location.href = window.routes?.cart_url || '/cart';
        } catch (e) {
          console.error(e);
        } finally {
          if (submit) {
            submit.classList.remove('loading');
            submit.removeAttribute('aria-disabled');
          }
          if (spinner) spinner.classList.add('hidden');
        }
      },
      true
    );
  }

  function boot() {
    document.querySelectorAll('product-form form').forEach(enhanceProductForm);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('product-info:loaded', boot);
})();
